import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  loading: false,
  loadingNext: false,
  vehicles: [],
  currentVehicle: null,
  nextLink: null,
  total: 0,
};

// Actions
const SET_VEHICLES = 'vehicle-section/SET_VEHICLES';
const SET_LOADING = 'vehicle-section/SET_LOADING';
const SET_CURRENT_VEHICLE = 'vehicle-section/SET_CURRENT_VEHICLE';
const SET_CLEAR_VEHICLES = 'vehicle-section/SET_CLEAR_VEHICLES';
const SET_NEXT_VEHICLES_LINK = 'vehicle-section/SET_NEXT_VEHICLES_LINK';
const SET_TOTAL_VEHICLES = 'vehicle-section/SET_TOTAL_VEHICLES';
const SET_LOADING_NEXT = 'vehicle-section/SET_LOADING_NEXT';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_VEHICLES](state, vehicles) {
    return {
      ...state,
      vehicles: [...state.vehicles, ...vehicles],
    };
  },
  [SET_LOADING](state, loading) {
    return {
      ...state,
      loading,
    };
  },
  [SET_LOADING_NEXT](state, loadingNext) {
    return {
      ...state,
      loadingNext,
    };
  },
  [SET_CURRENT_VEHICLE](state, currentVehicle) {
    return {
      ...state,
      currentVehicle,
    };
  },
  [SET_NEXT_VEHICLES_LINK](state, nextLink) {
    return {
      ...state,
      nextLink,
    };
  },
  [SET_TOTAL_VEHICLES](state, total) {
    return {
      ...state,
      total,
    };
  },
  [SET_CLEAR_VEHICLES](state) {
    return INIT_STATE;
  },
});

// Action creators
export const setVehicles = (vehicles) => ({
  type: SET_VEHICLES,
  payload: vehicles,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setLoadingNext = (loading) => ({
  type: SET_LOADING_NEXT,
  payload: loading,
});

export const setCurrentVehicle = (currentVehicle) => ({
  type: SET_CURRENT_VEHICLE,
  payload: currentVehicle,
});

export const setClearVehicles = () => ({
  type: SET_CLEAR_VEHICLES,
});

export const setNextVehiclesLink = (nextLink) => ({
  type: SET_NEXT_VEHICLES_LINK,
  payload: nextLink,
});

export const setTotalVehicles = (total) => ({
  type: SET_TOTAL_VEHICLES,
  payload: total,
});
